import React, { useState } from 'react';
import ListItem from "@mui/material/List";
import { Link} from 'react-scroll'
import './style.css';

const menus = [
    { id: 1, title: 'Home',        link: 'home',    offset: -100 },
    { id: 2, title: 'About',       link: 'about',   offset: -95  },
    { id: 3, title: 'Media',       link: 'blog',    offset: -95  },
    { id: 4, title: 'Collaborate', link: 'service', offset: -95  },
    { id: 5, title: 'Gallery',     link: 'project', offset: -95  },
    { id: 6, title: 'Blog',        link: 'blogs',   offset: -95  },
    { id: 7, title: 'Contact',     link: 'contact', offset: -95  },
]


const MobileMenu = () => {

    const [menuActive, setMenuState] = useState(false);

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem key={mn}>
                            <Link
                                to={item.link} spy={true} smooth={true} duration={500} offset={item.offset}
                                onClick={() => setMenuState(false)}>{item.title}</Link>
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;